// Per design rule: everyone sees property time, not their local time.
// The timezone is set at runtime once Property loads.

let propertyTz = 'Australia/Sydney';

export function setPropertyTimezone(tz: string) {
  propertyTz = tz;
}

export function getPropertyTimezone() {
  return propertyTz;
}

export function fmtClock(iso: string | Date): string {
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  return d.toLocaleString('en-AU', {
    timeZone: propertyTz,
    weekday: 'short', day: '2-digit', month: 'short',
    hour: '2-digit', minute: '2-digit', hour12: false,
  });
}

export function fmtDate(iso: string | Date): string {
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  return d.toLocaleString('en-AU', {
    timeZone: propertyTz,
    day: '2-digit', month: 'short', year: 'numeric',
  });
}
